import { render, staticRenderFns } from "./Yuqingleixingfenxi.vue?vue&type=template&id=3837bc1b&scoped=true&"
import script from "./Yuqingleixingfenxi.vue?vue&type=script&lang=js&"
export * from "./Yuqingleixingfenxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837bc1b",
  null
  
)

export default component.exports